import {
  RoutedBreadcrumbContext,
  IRoutedBreadcrumbContextProps,
} from 'api/ApplicationContext/RoutedBreadcrumbContext';
import { useContext } from 'react';

export function useRoutedBreadcrumbLookup(): IRoutedBreadcrumbContextProps {
  return useContext(RoutedBreadcrumbContext);
}
